import React from 'react';
import { getLoggedUser } from '../../../../state/user';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import FilterSection from '../../../common/Filter';
import Dropdown from '../../../common/DropDown';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import { tableStyles } from '../../../../styles/components/js/tableStyle';
import DataTable from 'react-data-table-component';
import { CreditCard, Download, FileSpreadsheet, Printer, ShoppingCart } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import NewDropdown from '../../../common/NewDropDown';
import { getWinningAuctions, getWinningClients } from './services/mzadcomPaymentService';
import StatusBadge from '../../../common/StatusBadge';
import { AUCTION_APPROVE_STATUS } from '../../../../constants/status';
import { apiUrl } from '../../../../constants/global';
import { MzadcomPayModal } from './components/MzadcomPayModal';
import { getGroupsList } from '../../../../models/groups';
import { ClientAmountCard } from '../../../common/ClientAmountCard';
import HeaderBanner from '../../../common/HeaderBanner';
import { PaymentHistory } from './components/PaymentHistory';
// import { PaymentHistory } from './components/PaymentHistory';

const user = getLoggedUser();

export class MzadcomPaymentList extends React.Component {
  constructor() {
    super();
    this.state = {
      search: {
        client: '',
        group: '',
      },
      status: 'approved',
      clients: [],
      groups: [],
      winningAuctions: [],
      selectedRows: [],
      isloading: false,
      limit: 15,
      page: 1,
      total: 0,
      totalClientAmount: 0,
      totalClientDue: 0,
      totalClientPaid: 0,
      totalPendingPayment: 0,
      showModal: false,
      showTransaction: false,
      groupLoading: false,
      activeTab: 'approved',
      cardMeta: [
        { type: 'approved', title: i18n.t('approved_due'), amount: 0, auctionCount: 0 },
        { type: 'pending', title: i18n.t('pending_due'), amount: 0, auctionCount: 0 },
        { type: 'total', title: i18n.t('total_amount'), amount: 0, auctionCount: 0 },
        { type: 'paid', title: i18n.t('paid_amount'), amount: 0, auctionCount: 0 },
      ],
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    // Parse URL query params
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status') || 'approved';
    const search = {
      client: params.get('client') || '',
      group: params.get('group') || null,
      status: status,
    };
    const page = parseInt(params.get('page')) || 1;
    const limit = parseInt(params.get('limit')) || 15;

    this.setState({ search, page, limit, status, activeTab: status }, () => {
      this.getAllOrganization?.();
      this.getWinningAuctions();
    });
  }

  // Update URL without refreshing page
  updateUrlQuery(q) {
    const queryString = new URLSearchParams(
      Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
    ).toString();
    window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
  }
  async getWinningAuctions() {
    this.setState({ isloading: true });
    let { limit, page, status } = this.state;
    let { client, group } = this.state.search;
    const q = {
      page: page,
      limit: limit,
    };

    if (client) q.client = client;
    if (group) q.group = group;
    if (status) {
      switch (status) {
        case 'approved':
          q.status = 'approved';
          break;
        case 'pending':
          q.status = 'pending';
          break;
        case 'paid':
          q.status = 'paid';
          break;
        case 'total':
          q.status = 'all';
          break;
        default:
          break;
      }
    }

    // Update URL
    this.updateUrlQuery(q);

    let response = await getWinningAuctions(q);
    if (response.success) {
      let winningAuctions = response.data;
      let {
        total,
        total_amount,
        paid_amount,
        due_amount,
        paid_pending_amount,
        pending,
        approved,
        all,
        paid,
      } = response.meta;

      this.setState({
        winningAuctions,
        total,
        totalClientAmount: total_amount,
        totalClientDue: due_amount,
        totalClientPaid: paid_amount,
        totalPendingPayment: paid_pending_amount,
        isloading: false,
        cardMeta: [
          {
            type: 'approved',
            title: i18n.t('approved_due'),
            amount: approved.balance,
            auctionCount: approved.count,
          },
          {
            type: 'pending',
            title: i18n.t('pending_due'),
            amount: pending.balance,
            auctionCount: pending.count,
          },
          {
            type: 'total',
            title: i18n.t('total_amount'),
            amount: all.balance,
            auctionCount: all.count,
          },
          {
            type: 'paid',
            title: i18n.t('paid_amount'),
            amount: paid.total,
            auctionCount: paid.count,
          },
        ],
      });
    }
    this.setState({ isloading: false });
  }
  async getAllOrganization() {
    const response = await getWinningClients();
    let clients = response.data;
    this.setState({ clients });
  }

  async getAllGroups() {
    this.setState({ groupLoading: true });
    let { client } = this.state.search;
    let q = client ? `organization=${client}` : '';
    const response = await getGroupsList(q);
    if (response.success) {
      let groups = response.data;
      this.setState({ groups });
      this.setState({ groupLoading: false });
    } else {
      this.setState({ groupLoading: false });
    }
  }

  getColumns = () => {
    const { winningAuctions, selectedRows } = this.state;
    const isArabic = i18n.language === 'ar';

    return [
      {
        name: (
          <input
            type="checkbox"
            checked={
              winningAuctions.length > 0 &&
              selectedRows.length > 0 &&
              selectedRows.length ===
                winningAuctions.filter(
                  (r) => r.approve_status === 'A' && Number(r.balance_amount) > 0
                ).length
            }
            onChange={() =>
              this.handleCheckAll(
                winningAuctions.filter(
                  (r) => r.approve_status === 'A' && Number(r.balance_amount) > 0
                )
              )
            }
            aria-label="Select all eligible rows"
          />
        ),
        cell: (row) => (
          <input
            type="checkbox"
            disabled={row.approve_status !== 'A' || Number(row.balance_amount) <= 0}
            checked={selectedRows.includes(row)}
            onChange={() => this.handleCheckboxChange(row)}
            aria-label={`Select row ${row.id}`}
          />
        ),
        width: '50px',
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        name: 'Sl No',
        width: '70px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: 'ID',
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => <span className="highlight-table-value">MZAD {row.id}</span>,
      },
      {
        name: i18n.t('auction_name'),
        minWidth: '180px',
        cell: (row) => (isArabic ? row.title_ar : row.title),
      },
      {
        name: i18n.t('client'),
        minWidth: '150px',
        cell: (row) => (isArabic ? row.organization_name_ar : row.organization_name),
      },
      {
        name: i18n.t('payment_progress'),
        width: '200px',
        sortable: false,
        wrap: true,
        cell: (row) => {
          const total = parseFloat(row.total_amount) || 0;
          const paid = parseFloat(row.paid_amount) || 0;
          const pending = parseFloat(row.pending_approval_amount) || 0;

          const paidPercent = total ? (paid / total) * 100 : 0;
          const pendingPercent = total ? (pending / total) * 100 : 0;

          return (
            <div className="payment-progress">
              <div className={`progress-bar ${i18n.dir() === 'rtl' ? 'rtl' : ''}`}>
                {/* Green - paid */}
                <div className="progress-fill paid" style={{ width: `${paidPercent}%` }}></div>

                {/* Yellow - pending approval */}
                <div
                  className="progress-fill pending"
                  style={{
                    width: `${pendingPercent}%`,
                    [i18n.dir() === 'rtl' ? 'right' : 'left']: `${paidPercent}%`,
                  }}
                ></div>
              </div>

              <div className="progress-summary">
                <div className="progress-item">
                  <span className="progress-dot paid"></span>
                  <span className="progress-label">
                    {i18n.t('approved')}: <strong>{paid.toFixed(2)}</strong>
                  </span>
                </div>
                <div className="progress-item">
                  <span className="progress-dot pending"></span>
                  <span className="progress-label">
                    {i18n.t('pending')}: <strong>{pending.toFixed(2)}</strong>
                  </span>
                </div>
                <div className="progress-total">
                  {i18n.t('total')}: <strong>{total.toFixed(2)}</strong>
                </div>
              </div>
            </div>
          );
        },
      },

      {
        name: i18n.t('paid_amount'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value">{row.total_paid ?? 0}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('total_amount'),
        width: '120px',
        cell: (row) => <span className="highlight-table-value">{row.total_amount ?? 0}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('payable_balance'),
        width: '140px',
        cell: (row) => <span className="highlight-table-value">{row.balance_amount ?? 0}</span>,
        wrap: true,
        right: true,
      },
      {
        name: i18n.t('invoice'),
        width: '130px',
        cell: (row) =>
          row.approve_status === 'A' ? (
            <a
              href={
                apiUrl +
                'my_winnings/pdf?' +
                new URLSearchParams({
                  id: user.id,
                  auction: row.id,
                }).toString()
              }
              target="_blank"
              rel="noreferrer"
              className="button-table"
            >
              {i18n.t('download')}
            </a>
          ) : (
            '-'
          ),
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('due_days'),
        width: '120px',
        cell: (row) => {
          if (!row.approved_date) return '-';

          const approvedDate = new Date(row.approved_date);
          const today = new Date();
          const diffTime = approvedDate.getTime() - today.getTime();
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          const isOverdue = diffDays < 0;
          const displayText = isOverdue
            ? `${Math.abs(diffDays)} days overdue`
            : `${diffDays} days left`;

          return (
            <span className={`highlight-table-value ${isOverdue ? 'overdue' : 'upcoming'}`}>
              {displayText}
            </span>
          );
        },
        wrap: true,
        center: true,
      },
      {
        name: i18n.t('client_approval'),
        width: '140px',
        cell: (row) => <StatusBadge status={AUCTION_APPROVE_STATUS[row.approve_status]} />,
        wrap: true,
        center: true,
      },
    ];
  };

  handleCheckboxChange = (row) => {
    this.setState((prev) => {
      const selectedRows = prev.selectedRows.includes(row)
        ? prev.selectedRows.filter((r) => r !== row)
        : [...prev.selectedRows, row];
      return { selectedRows };
    });
  };

  handleCheckAll = (rows) => {
    this.setState((prev) => {
      const allSelected = prev.selectedRows.length === rows.length;
      return { selectedRows: allSelected ? [] : rows };
    });
  };

  handleSearchChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => {
        const updatedSearch = { ...prevState.search, [name]: value };
        return { search: updatedSearch };
      },
      () => {
        if (name === 'client') {
          this.getAllGroups();
        }
      }
    );
  };

  handleSearch = () => {
    this.getWinningAuctions();
  };

  handleClear = () => {
    const defaultSearch = {
      client: '',
      group: '',
      // status: 'pending',
    };

    this.setState({ search: defaultSearch, page: 1, selectedRows: [] }, () => {
      this.getWinningAuctions();
    });
  };

  onChangePage = (page) => {
    console.log('page', page);

    this.setState({ page: page }, () => {
      this.getWinningAuctions();
    });
  };

  onChangeRowsPerPage = (limit) => {
    console.log('row', limit);
    this.setState({ limit: limit, page: 1 }, () => {
      this.getWinningAuctions();
    });
  };
  payNow = () => {
    this.setState({ showModal: true });
  };

  showPaymentHistory = () => {
    this.setState({ showTransaction: true });
  };

  handleCardSelect = (cardType) => {
    console.log(cardType);

    this.setState(
      (prevState) => ({
        activeTab: cardType,
        status: cardType,
        search: { ...prevState.search },
        page: 1,
        selectedRows: [], // Clear selected rows when changing tabs
      }),
      () => {
        this.getWinningAuctions();
      }
    );
  };

  render() {
    const {
      clients,
      groups,
      winningAuctions,
      totalClientDue,
      selectedRows,
      cardMeta,
      activeTab,
      groupLoading,
      totalPendingPayment,
      showTransaction,
    } = this.state;

    return (
      <React.Fragment>
        <HeaderBanner title={i18n.t('mzadcom_payment')} subtitle={i18n.t('track_successful_bid')} />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? 'col-xl-12 col-lg-12 col-md-12'
                    : 'col-xl-9 col-lg-12 col-md-12'
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                        onClick={() => {
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          });
                        }}
                      >
                        {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                        {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                      </span>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="header-action">
                      {/* Amount Waiting Card */}
                      <div className="pending-amount-card" onClick={this.showPaymentHistory}>
                        <span className="card-label-new">
                          {i18n.t('amount_waiting_for_approval')}
                        </span>
                        <span className="card-value-new">{totalPendingPayment} OMR</span>
                      </div>
                      <NewDropdown
                        label={i18n.t('export')}
                        // loading={export_loading}
                        icon={Download}
                        items={[
                          {
                            label: i18n.t('pdf'),
                            icon: Printer,
                            onClick: () => this.handleDownload('pdf'),
                          },
                          {
                            label: i18n.t('excel'),
                            icon: FileSpreadsheet,
                            disabled: true,
                          },
                        ]}
                      />
                    </div>

                    {/* Amount Cards */}
                    <div className="client-cards-container-new">
                      {cardMeta.map((config) => (
                        <ClientAmountCard
                          key={config.type}
                          {...config}
                          selected={activeTab === config.type}
                          onSelect={this.handleCardSelect}
                        />
                      ))}
                    </div>

                    <FilterSection
                      loading={this.state.isloading}
                      onSearch={this.handleSearch}
                      onClear={this.handleClear}
                    >
                      {/* Client Dropdown */}
                      <Dropdown
                        name="client"
                        value={this.state.search.client}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('client_name')}
                        empty={i18n.t('select_client')}
                        options={clients.map((c) => ({ value: c.id, label: c.organization_name }))}
                      />
                      {/* Group Dropdown */}
                      <Dropdown
                        name="group"
                        value={this.state.search.group}
                        onChange={this.handleSearchChange}
                        placeholder={i18n.t('auction_group')}
                        empty={groupLoading ? `${i18n.t('loading')}...` : i18n.t('select_group')}
                        options={groups.map((g) => ({ value: g.id, label: g.group_name }))}
                        disabled={groupLoading}
                      />
                    </FilterSection>

                    <div className="selected-box">
                      <div className="selected-box-content">
                        <ShoppingCart size={22} className="selected-box-icon" />
                        <span className="selected-box-text">
                          {selectedRows.length} {i18n.t('auctions_selected')}
                        </span>
                      </div>
                      <ActionButton
                        key="pay_now"
                        label="pay_now"
                        icon={<CreditCard strokeWidth={1.5} />}
                        variant="button1-gradient"
                        active={totalClientDue === 0 || !selectedRows.length ? true : false}
                        onClick={this.payNow}
                      />
                    </div>

                    <div className="Data-Listing">
                      {this.state.isloading ? (
                        <TableSkeleton columns={10} rows={10} />
                      ) : this.state.winningAuctions.length ? (
                        <DataTable
                          keyField={(row) => `${row.id}`}
                          responsive={true}
                          columns={this.getColumns()}
                          data={winningAuctions}
                          customStyles={tableStyles}
                          highlightOnHover
                          pagination
                          paginationServer
                          paginationTotalRows={this.state.total}
                          paginationPerPage={this.state.limit}
                          paginationDefaultPage={this.state.page}
                          paginationRowsPerPageOptions={[15, 25, 50, 100]}
                          paginationComponentOptions={{
                            rowsPerPageText: i18n.t('payments_per_page'),
                            rangeSeparatorText: i18n.t('out'),
                          }}
                          onChangePage={this.onChangePage}
                          onChangeRowsPerPage={this.onChangeRowsPerPage}
                        />
                      ) : (
                        <NoData
                          message={i18n.t('no_auctions_available')}
                          actionText={i18n.t('refresh')}
                          onAction={this.getWinningAuctions.bind(this)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <MzadcomPayModal
          show={this.state.showModal}
          selectedAuctions={selectedRows}
          onClose={() => this.setState({ showModal: false })}
          user={user}
          onPaymentComplete={() => {
            this.getWinningAuctions();
            this.setState({ showModal: false, selectedRows: [] });
          }}
        />

        <PaymentHistory
          show={showTransaction}
          onClose={() => this.setState({ showTransaction: false })}
        />
      </React.Fragment>
    );
  }
}

const ActionButton = ({
  label,
  icon,
  to,
  variant = 'button1-gradient',
  onClick,
  active = false,
}) => {
  if (to) {
    return (
      <NavLink
        to={to}
        className={`button1 `}
        style={{ whiteSpace: 'nowrap', cursor: 'pointer', marginRight: '4px' }}
      >
        {icon} {i18n.t(label)}
      </NavLink>
    );
  }

  return (
    <button disabled={active} className={`button1 ${variant}`} onClick={onClick}>
      {icon} {i18n.t(label)}
    </button>
  );
};
